import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export type CompareItem = {
  agilityId: number;
  image: string;
  modelCode: string;
  productName: string;
};

export type CompareState = {
  showCompare: boolean;
  items: CompareItem[];
};

export const initialCompareState: CompareState = {
  showCompare: false,
  items: [],
};

export const exampleCompareState: CompareState = {
  showCompare: false,
  items: [],
};

const slice = createSlice({
  initialState: initialCompareState,
  name: 'compare',
  reducers: {
    toggle: (state) => {
      state.showCompare = !state.showCompare;
    },
    addRemoveProduct: (state: CompareState, action: PayloadAction<CompareItem>) => {
      if (state.items.find((r) => r.agilityId === action.payload.agilityId)) {
        state.items = state.items.filter((r) => r.agilityId !== action.payload.agilityId);
      } else {
        state.items.push(action.payload);
      }
    },
    addRemoveProductBulk: (state: CompareState, action: PayloadAction<CompareItem[]>) => {
      action.payload.forEach((item) => {
        if (state.items.find((r) => r.agilityId === item.agilityId)) {
          state.items = state.items.filter((r) => r.agilityId !== item.agilityId);
        } else {
          state.items.push(item);
        }
      });
    },
    clear: (state) => {
      state.items = [];
    },
  },
});

export const { toggle, addRemoveProduct, addRemoveProductBulk, clear } = slice.actions;
export const name = slice.name;
export const reducer = slice.reducer;
